import * as React from 'react';
import classnames from 'classnames';
import { CheckboxWithLabel } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { CLPrescriptionSelectContainer } from '../CLPrescriptionSelect/CLPrescriptionSelectContainer.js';
import { CLQuantitySelectorContainer } from '../CLQuantitySelector/CLQuantitySelectorContainer.js';
import { CLStockIndicator } from '../CLStockIndicator/CLStockIndicator.js';

const CLPrescriptionColumn = /*#__PURE__*/ React.memo(({ eyeSideId , className , columnTitle , parameters , isEnabled , showCheckboxError , onCheckboxChange , onAttributeChange , 'data-t': dataT  })=>{
    const { getLabel  } = useIntl();
    const screenreaderTitle = `${getLabel('products.contactLenses.prescription.title')} ${columnTitle}`;
    const handleAttributeChange = React.useCallback((name, value)=>onAttributeChange(name, value, eyeSideId)
    , [
        eyeSideId,
        onAttributeChange
    ]);
    const handleCheckboxChange = React.useCallback(({ checked  })=>onCheckboxChange(checked, eyeSideId)
    , [
        eyeSideId,
        onCheckboxChange
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('cl-prescription-column', className),
        "aria-label": screenreaderTitle,
        "data-t": dataT,
        role: "group"
    }, /*#__PURE__*/ React.createElement(CheckboxWithLabel, {
        id: eyeSideId,
        value: eyeSideId,
        checked: isEnabled,
        className: classnames('cl-prescription-column__title', `${className}--checkbox`),
        "data-t": "prescription-checkbox",
        label: columnTitle,
        onChange: handleCheckboxChange,
        disabled: false,
        error: showCheckboxError
    }), parameters.map((attributeConfig)=>/*#__PURE__*/ React.createElement(CLPrescriptionSelectContainer, {
            key: attributeConfig.name,
            selectClassName: "cl-prescription-column__dropdown",
            attributeConfig: attributeConfig,
            eyeSideId: eyeSideId,
            isDisabled: !isEnabled,
            onChange: handleAttributeChange
        })
    ), /*#__PURE__*/ React.createElement(CLQuantitySelectorContainer, {
        eyeSideId: eyeSideId,
        className: "cl-prescription-column__quantity-select",
        isEnabled: isEnabled
    }), /*#__PURE__*/ React.createElement(CLStockIndicator, {
        eyeSideId: eyeSideId,
        className: classnames('cl-prescription-column__stock', `${className}--stock`)
    }));
});

export { CLPrescriptionColumn };
//# sourceMappingURL=CLPrescriptionColumn.js.map
